export class Region {
	constructor(data) {
		this._id = data._id;
		this.name = data.name;
		this.terms_and_conditions = data.terms_and_conditions;
	}
}
